module.exports = __webpack_public_path__ + "assets/img/free_26.7ece2332.png";